import { render, staticRenderFns } from "./ProjectionCanvas.vue?vue&type=template&id=9ecd2138&scoped=true&"
import script from "./ProjectionCanvas.vue?vue&type=script&lang=js&"
export * from "./ProjectionCanvas.vue?vue&type=script&lang=js&"
import style0 from "./ProjectionCanvas.vue?vue&type=style&index=0&id=9ecd2138&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ecd2138",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
